/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect} from 'react'
import Table from 'react-bootstrap/Table'
import Button from 'react-bootstrap/Button'
import {PageTitle} from '../../../../_metronic/layout/core'
import Form from 'react-bootstrap/Form'
import {Col, Dropdown, Modal, Row, Spinner} from 'react-bootstrap'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {useNavigate} from 'react-router-dom'
import useServices from '../../../../utils/hooks/useServices'
import useDebounce from '../../../../utils/hooks/useDebounce'
import MasterServices from '../../../../services/master'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../utils/helpers/FormGenerator'
import CompanyServices from '../../../../services/company'
import {dateFormat} from 'thesis-and-dissertations/helpers/helper'

let active = 1
let items: any = []
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>
  )
}

const heads = [
  {
    name: '',
    label: 'Nama Perusahaan',
  },
  {
    name: '',
    label: 'Tanggal Daftar',
  },
  {
    name: '',
    label: 'Jenis Industri',
  },
  {
    name: '',
    label: 'MoU',
  },
  {
    name: '',
    label: 'Pengantar dan Persyaratan',
  },
  {
    name: '',
    label: 'Status',
  },
  {
    name: '',
    label: 'Aksi',
  },
]

const CompanyPage: FC = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })
  const [filter, setFilter] = useState<any>({
    city_id: [],
    industry_id: [],
    ownership_id: [],
  })
  const [show, setShow] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc'})
  const [formValue, setFormValue] = useState<any>({status: '', company_id: ''})
  const [submit, setSubmit] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [loadingMaster, setLoadingMaster] = useState<boolean>(false)
  const [selected, setSelected] = useState<any>([])
  const [counter, setCounter] = useState<any>(1)
  const [data, loading, empty, refresh, isError, setLoading] = useServices(
    MasterServices.getCompanyHash,
    {
      ...query,
      page: pagination.page,
      sort_field: 'created_at',
      per_page: pagination.per_page,
      status: [0, 1],
      is_company: true,
      city_id: filter.city_id,
      industry_id: filter.industry_id,
      ownership_id: filter.ownership_id,
    },
    []
  )

  const [role, setRole] = useState<string>('')

  useEffect(() => {
    fetchIndustry()
    fetchCity()
    fetchOwnership()

    setRole(localStorage.getItem('keyRole') ?? '')
  }, [])

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
  }, [pagination.per_page, pagination.page])

  useEffect(() => {
    refresh()
    generateTotalPage(pagination.total_page)
    setShowFilter(false)
  }, [filter])

  useDebounce(refresh, 250, [query.q, query.sort_order])

  const paginator: any = usePagination({
    totalCount: data?.data?.total,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  const [inputs, setInputs] = useState([
    {
      name: 'city_id',
      label: 'Lokasi',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'cities_name',
      getItemValueId: 'cities_id',
    },
    {
      name: 'industry_id',
      label: 'Industri',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'industries_name',
      getItemValueId: 'industries_id',
    },
    {
      name: 'ownership_id',
      label: 'Kepemilikan',
      type: 'select2',
      validation: {},
      col: 12,
      options: [],
      additional: '',
      getItemValue: 'company_ownerships_name',
      getItemValueId: 'company_ownerships_id',
    },
  ])

  const toggleFilter = () => setShowFilter(!showFilter)

  const StatusComponent = (type: string, obj?: any) => {
    if (type === '0') {
      return (
        <Button className='shadow-none btn-sm btn-sm btn-outline btn-outline-dark'>
          Non-Aktif
        </Button>
      )
    }
    if (type === '1') {
      return (
        <Button className='shadow-none btn btn-sm btn-outline btn-outline-success'>Aktif</Button>
      )
    }
    if (type === '2') {
      return <Button variant='danger'>Non-Aktif</Button>
    }
    if (type === '3') {
      return <Button variant='secondary'>Tutup</Button>
    }
  }

  const handleApprove = async () => {
    try {
      setSubmit(true)
      await MasterServices.approveCompany(formValue)
      toast.success('Proses berhasil dilakukan')
      refresh()
    } catch (error) {
    } finally {
      refresh()
      setSubmit(false)
    }
  }

  const toggle = () => {
    if (show) {
      setFormValue({})
    }
    setShow(!show)
  }

  const fetchCity = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getCity({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[0].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchIndustry = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getIndustry({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[1].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const fetchOwnership = async (q = '') => {
    setLoadingMaster(true)
    await MasterServices.getCompanyOwnership({...{is_active: 1}, q})
      .then((response) => {
        const {data} = response.data
        inputs[2].options = data
        setInputs(inputs)
        setLoadingMaster(false)
      })
      .catch((err) => {
      })
  }

  const onKeyUp = (input: any, value: any, key: any) => {
    const name = input
    switch (name) {
      case 'city_id':
        fetchCity(value)
        break
      case 'industry_id':
        fetchIndustry(value)
        break
      case 'ownership_id':
        fetchOwnership(value)
        break
    }
  }

  const handleCheck = (param: any) => {
    let newSelected: any = selected || []

    if (param === 'all') {
      if (selected?.length > 0) {
        newSelected = []
      } else {
        data?.data?.data?.forEach((item: any) => {
          return newSelected.push({
            company_id: item.company_id,
          })
        })
      }
    } else {
      const check = selected?.filter((f: any) => param === f.company_id)
      if (check.length < 1) {
        newSelected.push({
          company_id: param,
          status: 1,
        })
      } else {
        newSelected = selected?.filter((f: any) => f.company_id !== param)
      }
    }

    setSelected(newSelected)
    setCounter((val: any) => val + 1)
  }

  const generateTotalPage = (totalPage: number) => {
    let total = 0
    let newTotal: any = []

    for (total = 0; total < totalPage; total++) {
      if (total < 4) {
        newTotal.push(total + 1)
      } else if (total === 8) {
        newTotal.push('...')
        newTotal.push(totalPage)
      }
    }
    return newTotal
  }

  const onChangePerPage = (per_page: number, to_page = 1) => {
    setPagination({
      ...pagination,
      per_page: per_page,
      page: to_page || 1,
    })
  }

  const onChange = (e: any) => {
    const {name, value} = e.target
    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const handleChangeStatus = async (id: any, status: any, companyName: any, ownerShip: any) => {
    try {
      if (window.confirm('Yakin ingin Mengubah status Perusahaan ?')) {
        setLoading(true)
        await MasterServices.updateCompany({
          company_id: id,
          status: status,
          id: id,
          company_name: companyName,
          ownership_id: ownerShip,
        })
        toast.success(`Status Perusahaan Berhasil Diperbarui`)
        refresh()
      }
    } catch (error) {
      refresh()
    }
  }

  const handleFilter = () => {
    setFilter({
      city_id: formValue?.city_id?.cities_id ? [formValue?.city_id?.cities_id] : [],
      industry_id: formValue?.industry_id?.industries_id
        ? [formValue?.industry_id?.industries_id]
        : [],
      ownership_id: formValue?.ownership_id?.company_ownerships_id
        ? [formValue?.ownership_id?.company_ownerships_id]
        : [],
    })
  }

  const handleReset = () => {
    setFormValue({})
  }

  const actionBulkDelete = async (companiesId: any) => {
    try {
      setLoading(true)
      await CompanyServices.multipleDeleteCompany({companies_id: companiesId})
      toast.success(`Perusahaan Berhasil Dihapus`)
      return
    } catch (error) {
    } finally {
      refresh()
    }
  }

  const handleBulkDelete = async () => {
    if (window.confirm('Yakin ingin hapus data?')) {
      let companiesId: any = []
      selected?.map((item: any) => {
        companiesId.push(item.company_id)
      })

      actionBulkDelete(companiesId)
    }
  }

  return (
    <>
      <div className='row'>
        <Modal show={showFilter} onHide={submit ? () => null : toggleFilter} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title> Filter</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>{FormGenerator(inputs, formValue, onChange, onKeyUp, loadingMaster)}</Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={() => handleReset()}>
              Reset
            </Button>
            <Button onClick={() => handleFilter()}>Terapkan</Button>
          </Modal.Footer>
        </Modal>
        <Modal show={show} onHide={toggle} size='lg'>
          <Modal.Header closeButton>
            <Modal.Title>Verifikasi Perusahaan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={12}>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    onChange={(e: any) => setFormValue({...formValue, status: e.target.value})}
                  >
                    {[
                      {name: 'Verifikasi 1', value: '0'},
                      {name: 'Aktif', value: '1'},
                      {name: 'Ditolak', value: '2'},
                      {name: 'Tutup', value: '3'},
                    ].map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={item.value}
                          selected={formValue.status === item.value}
                        >
                          {item.name}
                        </option>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant='secondary' onClick={toggle} disabled={submit}>
                  Batalkan
                </Button>
                <Button variant='primary' disabled={submit} onClick={handleApprove}>
                  {submit ? 'Loading' : 'Simpan'}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <div className='col-md-12'>
          <div className='card-custom' style={{paddingBottom: '80px'}}>
            <Row>
              <Col md={{span: 4}}>
                <Form.Control
                  placeholder='Cari...'
                  name='q'
                  onChange={(e) => setQuery({...query, q: e.target.value})}
                />
              </Col>
              <Col md={{span: 2, offset: 4}}>
                <Button type='button' onClick={toggleFilter} className='form-control'>
                  Filter
                </Button>
              </Col>
              <Col md={{span: 2}}>
                <Form.Select
                  aria-label='Default select example'
                  className='mr-8'
                  onChange={(e) => {
                    setQuery({...query, sort_order: e.target.value})
                  }}
                >
                  <option value='desc'>Terbaru</option>
                  <option value='asc'>Terlama</option>
                </Form.Select>
              </Col>
            </Row>

            {selected.length > 0 && (
              <Row>
                <Col md={{span: 2}}>
                  <Button
                    onClick={() => handleBulkDelete()}
                    type='button'
                    className='mt-8 btn btn-secondary'
                  >
                    Hapus data terpilih ?
                  </Button>
                </Col>
              </Row>
            )}
            <Row md={12} className='mt-8'>
              <Table responsive className='table-striped align-middle'>
                <thead>
                  <tr>
                    <th>
                      {role != 'BPK' && (
                        <Form.Check
                          onClick={() => handleCheck('all')}
                          checked={
                            data?.data?.data.length === selected.length &&
                            data?.data?.data?.length > 0
                          }
                        />
                      )}
                    </th>
                    {heads.map((item, index) => (
                      <th key={index} style={{maxWidth: item.label == 'Aksi' ? '100px' : ''}}>
                        {item.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.data?.data?.length === 0 && !loading && (
                    <tr>
                      <td colSpan={8} align='center'>
                        Tidak ada Data
                      </td>
                    </tr>
                  )}
                  {loading ? (
                    <tr>
                      <td colSpan={8} align='center'>
                        <Spinner
                          animation='border'
                          role='status'
                          style={{height: '100px', width: '100px'}}
                        />
                      </td>
                    </tr>
                  ) : (
                    data.data?.data?.map((item: any, key: any) => {
                      if (item.companies_status == '0' || item.companies_status == '1') {
                        return (
                          <tr key={key}>
                            <td>
                              {role != 'BPK' && (
                                <Form.Check
                                  onChange={() => handleCheck(item.company_id)}
                                  checked={
                                    selected.filter((f: any) => f.company_id === item.company_id)
                                      .length > 0
                                      ? true
                                      : false
                                  }
                                />
                              )}
                            </td>
                            <td>{item.companies_name}</td>
                            <td>{dateFormat(item.created_at)}</td>
                            <td>{item.industry?.industries_name || '-'}</td>
                            <td>
                              <a href={item.companies_mou} target='_blank'>
                                MoU
                              </a>
                            </td>
                            <td>
                              <a
                                href={item.companies_introduction_and_requirements}
                                target='_blank'
                              >
                                Pengantar dan Persyaratan
                              </a>
                            </td>
                            <td>{StatusComponent(item.companies_status, item) || '-'}</td>
                            <td>
                              <Dropdown>
                                <Dropdown.Toggle
                                  id='dropdown-basic'
                                  className='btn btn-primary btn-sm'
                                >
                                  {'  '}
                                  Aksi
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => {
                                      navigate(
                                        `/crafted/pages/profile/company-overview?company=${item.companies_id}`
                                      )
                                    }}
                                  >
                                    Lihat
                                  </Dropdown.Item>
                                  {/* {item.companies_status != '0' && ( */}

                                  {role != 'BPK' && (
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleChangeStatus(
                                          item.companies_id,
                                          item.companies_status === '0' ? '1' : '0',
                                          item.companies_name,
                                          item.company_ownership?.company_ownerships_id
                                        )
                                      }
                                    >
                                      {item.companies_status === '0' ? 'Aktifkan' : 'Non-Aktifkan'}
                                    </Dropdown.Item>
                                  )}
                                  {/* )} */}
                                </Dropdown.Menu>
                              </Dropdown>
                              {/* <Button
                                className='btn-sm'
                                onClick={() => {
                                  // setFormValue({
                                  //   id: item.countries_id,
                                  //   name: item.cities_name,
                                  //   province_id: item.province?.provinces_id,
                                  //   is_active: item.provinces_is_active,
                                  // })
                                  // toggle()
                                }}
                              >
                                Edit
                              </Button> */}
                            </td>
                          </tr>
                        )
                      }
                    })
                  )}
                </tbody>
              </Table>
            </Row>
            <Row>
              <Col md={6}>
                {data?.data?.data?.length > 0 && !loading && (
                  <div style={{float: 'left'}}>
                    <Dropdown>
                      <Dropdown.Toggle className='btn btn-sm'>
                        {pagination.per_page}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {[10, 25, 50, 100].map((item: any) => (
                          <Dropdown.Item
                            key={item}
                            href='#/action-1'
                            onClick={() => onChangePerPage(item)}
                            disabled={pagination.per_page === item}
                          >
                            {item}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </Col>
              <Col md={6}>
                <div style={{float: 'right'}}>
                  {!loading && (
                    <Pagination className='btn-sm'>
                      {paginator?.map((item: any) => {
                        return (
                          <Pagination.Item
                            className='btn-sm'
                            key={item}
                            active={item === pagination.page}
                            onClick={() => onChangePerPage(pagination.per_page, item)}
                            disabled={item === '...'}
                          >
                            {item}
                          </Pagination.Item>
                        )
                      })}
                    </Pagination>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  )
}

const Company: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Dashboard',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '/',
            path: '',
            isSeparator: false,
            isActive: false,
          },
        ]}
      >
        Semua Perusahaan
      </PageTitle>
      <CompanyPage />
    </>
  )
}

export default Company
